import React from 'react'

import {Button, Card, Drawer, Form, Icon, Tooltip} from 'antd'
import _ from 'lodash'
import Request from '../../request'
import {connect} from 'react-redux'
import moment from 'moment';

let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';

class SelectedStudentInvoices extends React.Component {
    state = {
        visible: true,
        selectedStudents: [],
        universityCommissions: []
    }

    loadInvoiceDetail = async() => {
        const { selectMultipleRecords } = this.props;
        var universityId = [];
        let studentIds = [];
        for(let key in selectMultipleRecords) {
            let obj = selectMultipleRecords[key];
            universityId.push(obj.universityId);
            studentIds.push(obj.studentId);
        }
        let uniResponse = await Request.getCommissionUniversities({universityId});
        let universityCommissions = []
        if(uniResponse.data) {
            uniResponse.data.map((comm, index) => {
                universityCommissions[comm.universityId._id] = {
                    commissionFromUniversity: comm.commissionFromUniversity,
                    commissionTypeFrom: comm.commissionTypeFrom
                };
            })
        }
        this.setState({universityCommissions});
        
        let response = await Request.loadDashboardStudentList({
            arr: studentIds,
            results: 10000,
        });
        if(response.data) {
            let selectedStudents = [];
            for(let key in selectMultipleRecords) {
                let obj = selectMultipleRecords[key];
                _.each(response.data, (std) => {
                    if(std._id == obj.studentId) {
                        selectedStudents[key] = std
                    }                    
                })
            }
            this.setState({ selectedStudents: selectedStudents})
        }        
    }

    async componentDidMount () {
        await this.loadInvoiceDetail();
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }


    constructor(props) {
        super(props)
    }

    render() {
        const { selectMultipleRecords } = this.props;
        const { selectedStudents, universityCommissions } = this.state;
        let selectedInvoicesHtml = [];
        let totalLength = 0;
        for(let key in selectedStudents) {
            let selectedStudent = selectedStudents[key];
            totalLength++;
            selectedInvoicesHtml.push(
                <tr key={key}>
                    <td className='ant-table-row-cell-break-word'>{selectedStudent.visaDesk && selectedStudent.visaDesk.selectedCourse && selectedStudent.visaDesk.selectedCourse.instituteStudentId ? selectedStudent.visaDesk.selectedCourse.instituteStudentId : selectedStudent.instituteStudentId ? selectedStudent.instituteStudentId : ''}</td>
                    <td className='ant-table-row-cell-break-word'>{selectedStudent.studentName}</td>
                    <td className='ant-table-row-cell-break-word'>{selectedStudent.dateOfBirth ? moment(selectedStudent.dateOfBirth).format(dateFormat) : ''}</td>
                    <td className='ant-table-row-cell-break-word'>{selectedStudent.visaDesk ? selectedStudent.visaDesk.selectedCourse.courseName : ''}{selectedStudent.visaDesk ? selectedStudent.visaDesk.selectedCourse.campusName ? `(${selectedStudent.visaDesk.selectedCourse.campusName})` : '' : ''}</td>
                    <td className='ant-table-row-cell-break-word'>{selectedStudent.visaDesk ? moment(selectedStudent.visaDesk.courseStartDate).format(dateFormat) : ''}</td>
                    <td className='ant-table-row-cell-break-word'>
                        {
                            selectedStudent.nextInvoiceGenerationDates.map((date, index) => {
                                let ifChecked = selectMultipleRecords[key] && selectMultipleRecords[key].invoiceGeneratedRecordId == date._id ? true : false;
                                if(ifChecked) {
                                    return (<div key={index}>{moment(date.generationDate).format(dateFormat)}</div>);
                                }
                            })
                        }
                    </td>
                    <td className='ant-table-row-cell-break-word'>{selectedStudent && selectedStudent.visaDesk && (selectedStudent.visaDesk.selectedCourse.currency +'-'+selectedStudent.visaDesk.selectedCourse.tutionFee)}</td>
                    <td className='ant-table-row-cell-break-word'>{selectedStudent && selectedStudent.visaDesk ? universityCommissions[selectedStudent.visaDesk.selectedCourse.universityId].commissionFromUniversity : 'NA' }</td>
                    <td className='ant-table-row-cell-break-word'>{selectedStudent && selectedStudent.visaDesk ? (universityCommissions[selectedStudent.visaDesk.selectedCourse.universityId].commissionTypeFrom == 'Percentage' ? (parseFloat(universityCommissions[selectedStudent.visaDesk.selectedCourse.universityId].commissionFromUniversity) * parseFloat(selectedStudent.visaDesk.selectedCourse.tutionFee) / 100) : universityCommissions[selectedStudent.visaDesk.selectedCourse.universityId].commissionFromUniversity) : 'NA' }</td>
                </tr>
            )
        }
        return (
            <Drawer
                title={
                    <div>
                        {`Selected Student For Invoice:- ${totalLength}`}
                        <a onClick={this.onClose} style={{float: 'right', color: 'black'}}>
                            <Icon type={'close'}/>
                        </a>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                <Card>
                    <div className='ant-table ant-table-small ant-table-bordered ant-table-scroll-position-left ant-table-layout-fixed'>
                        <div className='ant-table-content'>
                            <div className='ant-table-scroll'>
                                <table className='ant-table-fixed' style={{width: '900px'}}>
                                    <thead className='ant-table-thead'>
                                        <tr>
                                            <th className='ant-table-row-cell-break-word'>Student ID</th>
                                            <th className='ant-table-row-cell-break-word'>Student Name</th>
                                            <th className='ant-table-row-cell-break-word'>Date Of Birth</th>
                                            <th className='ant-table-row-cell-break-word'>Course</th>
                                            <th className='ant-table-row-cell-break-word'>Start Term</th>
                                            <th className='ant-table-row-cell-break-word'>Invoice Date</th>
                                            <th className='ant-table-row-cell-break-word'>T. Fee Paid</th>
                                            <th className='ant-table-row-cell-break-word'>%/Flat</th>
                                            <th className='ant-table-row-cell-break-word'>Comm. Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody className='ant-table-tbody'>
                                        {
                                            selectedInvoicesHtml
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Card>
            </Drawer>
        )
    }
}
  
const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectedStudentInvoices)